<app-view-item *ngIf="readonly" [text]="selected?.code"></app-view-item>
<nz-select *ngIf="!readonly" #selector nzShowSearch nzServerSearch [nzAllowClear]="allowClear"
  [nzBackdrop]="addBackdrop" [nzFilterOption]="nzFilterOption" (nzOnSearch)="search($event)" (nzOpenChange)="search('')"
  (nzScrollToBottom)="loadMore()" [nzCustomTemplate]="displayTpl" [(ngModel)]="value"
  (keydown)="handleKeyDown($event)" (click)="handleClick($event)"
  (ngModelChange)="valueChanged($event)" [nzDropdownMatchSelectWidth]="false" [nzBorderless]="borderless" nzDropdownClassName="dropdownSelect"
  class="width-100">
  <ng-template #displayTpl let-selected>
    {{ selected.nzLabel }}
  </ng-template>

  <nz-option *ngIf="!searching && showAddNewButton" [nzValue]="''" nzCustomContent>
    <div class="text-center">
      <button type="button" nz-button nzType="primary" class="add-new-button" (click)="$event.stopPropagation(); openCurrencyModal($event)" acl="'currency.create'">
        <span nz-icon nzType="plus"></span>
        {{ instantData ? ' Add New \''+ instantData +'\'' : ' Add New' }}
      </button>
    </div>
  </nz-option>

  <ng-container *ngFor="let o of list">
    <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="o.code" nzCustomContent>
      <span>{{ o.code }}</span>
    </nz-option>
  </ng-container>
</nz-select>

<!-- <ng-template #renderTemplate>
  <div class="text-center" acl="currency.create">
    <button type="button" nz-button nzType="primary" (click)="newCurrency()">
      <span nz-icon nzType="plus"></span>
      {{ instantData ? ' Add New \''+ instantData +'\'' : ' Add New' }}
    </button>
  </div>
</ng-template> -->

<app-currency-modal></app-currency-modal>